import React from 'react';
import { Container } from 'semantic-ui-react';
import styles from './QuizDashboard.module.css';

const QuizDashboardSkeleton = () => (
    <div className={styles.page}>
        <div className={styles.skeletonHeader} />
        <Container className={styles.mainContainer}>
            {/* Action Cards */}
            <div className={styles.quickActionsRow}>
                <div className={styles.skeletonActions} />
                <div className={styles.skeletonActions} />
            </div>

            {/* Stats Row */}
            <div className={styles.statsRow}>
                {[1, 2, 3, 4].map(i => (
                    <div key={i} className={styles.skeletonStatsRow} />
                ))}
            </div>

            {/* Product Rows */}
            {[1, 2].map(row => (
                <div key={row} className={styles.productScrollSection} style={{ marginTop: row === 1 ? 32 : 0 }}>
                    <div className={styles.skeletonChip} style={{ width: 120, marginBottom: 12 }} />
                    <div className={styles.productScrollTrack}>
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} className={styles.skeletonProductRow} />
                        ))}
                    </div>
                </div>
            ))}

            {/* Activity */}
            <div className={styles.skeletonActivity} style={{ marginTop: 32 }} />
        </Container>
    </div>
);

export default QuizDashboardSkeleton;
